module.exports = __webpack_public_path__ + "static/scale-model-of-dallas-horseshoeing-service-in-allen-texas-4b9826593e7f52d21269698073540b6f.png";